import fixture from './CompanySearchByName.get.json';
import { fetchFixture } from 'utils/fetchFixture';
import { API_LOCATION_URL } from 'infrastructure/config';
import {
    IGetInput,
    IGetResponse,
    ICompanySearchByNameClient,
} from 'interfaceAdapter/gatewaySchemas/ICompanySearchByNameClient';
import { getCookie } from 'utils/cookie';
const csrfToken = getCookie('csrftoken');

export class CompanySearchByNameClient implements ICompanySearchByNameClient {
    async get(input: IGetInput): Promise<IGetResponse> {
        const { companyName, address, mock = false } = input;

        const method = 'GET';
        const headers: { [key: string]: string } = {
            'Content-Type': 'application/json',
        };
        const PATH = `${API_LOCATION_URL}/public/company_search_by_name?company_name=${companyName}${
            address ? `&address=${address}` : ''
        }`;
        if (csrfToken) {
            headers['X-CSRFToken'] = csrfToken;
        }
        try {
            const response = mock
                ? await fetchFixture(fixture)
                : await fetch(PATH, {
                      method,
                      headers,
                  });
            return response.json();
        } catch {
            throw new Error('処理に失敗しました');
        }
    }
}
